const midnightUTC = (from = new Date()) => {
  const midnight = new Date(from);
  midnight.setUTCHours(24, 0, 0, 0);
  return midnight;
};

const pluralize = (count, singular, plural = `${singular}s`) =>
  count === 1 ? `1 ${singular}` : `${count} ${plural}`;

/**
 * Returns a human-readable string for time until a target date.
 * Used to tell free users when their daily application allowance resets.
 *
 * Examples: "2 days", "1 day", "23 hours", "1 hour", "45 minutes", "1 minute"
 *
 * @param {Date} [now] - Defaults to the current time.
 * @param {Date} [target] - Defaults to midnight UTC after `now`.
 * @returns {string}
 */
export const timeUntil = (now = new Date(), target = midnightUTC(now)) => {
  const msLeft = target - now;
  const minutesLeft = Math.max(1, Math.round(msLeft / 60000));

  if (minutesLeft >= 24 * 60) {
    return pluralize(Math.round(minutesLeft / (24 * 60)), 'day');
  }
  if (minutesLeft >= 60) {
    return pluralize(Math.round(minutesLeft / 60), 'hour');
  }
  return pluralize(minutesLeft, 'minute');
};
